import { StyleSheet, View } from "react-native";

import { makeStyles } from "@/theme/makeStyles";
import { Text } from "@/ui/Text";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    bar: {
      minHeight: t.size.touchTarget + t.space.md,
      paddingHorizontal: t.space.lg,
      justifyContent: "center",
      backgroundColor: t.color.surface,
      borderBottomWidth: t.borderWidth.card,
      borderBottomColor: t.color.border,
    },
  }),
);

/**
 * The no-school header: the text "Akaiva Edu Power", never a logo (FR-027; R-9). Used before a school
 * is known: loading, entry, public addresses, not-found.
 */
export function ProductHeader() {
  const styles = useStyles();
  return (
    <View style={styles.bar} role="banner">
      <Text variant="heading" weight="semiBold" size="lg">
        Akaiva Edu Power
      </Text>
    </View>
  );
}
